<template>
    <div id="id-div-footer" class="div-footer" ref="refFooterDiv">
        <!--        <p style="text-align: center;color:#333333;">-->
        <!--            <a href="/">首页</a> | <a href="http://www.hdmooc.com/lab-center/index.html">在线实验室</a> | <a-->
        <!--                href="http://www.hdmooc.com/course/index.html">课程中心</a> |-->
        <!--            <a href="http://www.hdmooc.com/vrzone/index.html">VR智慧教室</a> | <a-->
        <!--                href="http://www.hdmooc.com/micro/index.html">微专业</a>-->
        <!--            | <a href="http://www.hdmooc.com/living/index.html">直播</a> | <a-->
        <!--                href="http://www.hdmooc.com/helper/index.html">帮助中心</a> | <a href="">学 · 问</a>-->
        <!--        </p>-->
        <!--        <p style="text-align: center;color:#333333;">-->
        <!--            <a href="http://www.hdmooc.com/pages/about.html">关于我们</a> | <a href="">联系我们</a> | <a-->
        <!--                href="http://www.hdmooc.com/helper/index.html">帮助中心</a> | <a-->
        <!--                href="http://www.hdmooc.com/pages/teacher.html">老师招募</a> | <a-->
        <!--                href="http://www.hdmooc.com/pages/user.html">服务协议</a>-->
        <!--        </p>-->
        <p style="text-align: center;color: #666666;">
            恒点信息(hdvrar.com)旗下实用技能学习平台</p>
        <p style="text-align: center;color: #666666;">
            &copy;2016-{{ endYear }}
            版权所有</p>
    </div>
</template>

<script>
export default {
    name: 'HdFooter',
    data () {
        return {
            endYear: 2019,
            footerLeft: 0
        }
    },
    created () {
        this.endYear = this.getCurrentYear()
    },
    mounted () {
        let that = this
        this.$nextTick(function () {
            that.setFooterLeft()
            window.addEventListener('setItemEvent', (e) => {
                if (e.key === 'WindowsOnResize') {
                    //刷新页面
                    that.setFooterLeft()
                }
            })
        })
    },
    methods: {
        setFooterLeft () {
            let width = this.$refs.refFooterDiv.offsetWidth
            this.footerLeft = (document.body.offsetWidth - width) / 2
        }
    }
}
</script>

<style scoped="scoped">
.div-footer {
    /*position: absolute;*/
    /*bottom: 1em;*/
    /*width: 100%;*/
}

a {
    color: #000000;
    text-decoration: none;
    margin-left: 0.5em;
    margin-right: 0.5em;
}

a:hover {
    color: #00a4e0;
}
</style>



// WEBPACK FOOTER //
// src/components/public/Footer.vue